import { render, staticRenderFns } from "./PropertySelectList.vue?vue&type=template&id=a1bbe9f6&"
import script from "./PropertySelectList.vue?vue&type=script&lang=js&"
export * from "./PropertySelectList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports